import { FAKE_PREFIXES } from './constants';
import { isoDateFormat } from '../date-time';
import moment from 'moment-timezone';

const tz = 'America/New_York';
const future = moment().tz(tz).day(1).add(1, 'week').startOf('day');
const isoFuture = future.format(isoDateFormat);

const startTime = future.clone().hour(9).minute(0);
const endTime = startTime.clone().add(50, 'minutes');

export const RESERVATION_TIME = {
  pristineStartTime: startTime,
  endTime,
  isReserved: true,
};

const CLINICIAN_DATA = [
  {
    id: `${FAKE_PREFIXES.CLINICIAN}-id-0`,
    firstName: 'Ellen',
    lastName: 'McCormack',
    globalProfessionName: 'psychology',
  },
  {
    id: `${FAKE_PREFIXES.CLINICIAN}-id-1`,
    firstName: 'Jonathan',
    lastName: 'Appleseed',
    globalProfessionName: 'psychology',
  },
];

const CPT_CODE_DATA = {
  id: `${FAKE_PREFIXES.CPT_CODE}-id`,
  description: 'Initial Consultation - No charge',
  duration: 50,
  rate: 0,
  callToBook: false,
};

const OFFICE_DATA = {
  id: `${FAKE_PREFIXES.OFFICE}-id`,
  name: 'Main Office',
  street: '123 main street',
  city: 'Los Angeles',
  state: 'CA',
  zip: '91101-0000',
  phone: '(310) 459-8816',
  isVideo: false,
  isPublic: true,
};

const SLOT_DATA = {
  id: isoFuture,
  date: isoFuture,
  spots: [
    {
      start: future.clone().hour(9).minute(0).format(),
      end: future.clone().hour(9).minute(50).format(),
    },
    {
      start: future.clone().hour(10).minute(0).format(),
      end: future.clone().hour(10).minute(50).format(),
    },
    {
      start: future.clone().hour(11).minute(0).format(),
      end: future.clone().hour(11).minute(50).format(),
    },
  ],
};

export const PRESCREENER_RESERVATION_ID = `${FAKE_PREFIXES.RESERVATION}-id`;

const findOrCreateStoreModel = (store, type, data) => {
  return store.peekRecord(type, data.id) || store.createRecord(type, data);
};

export const createFakeClinicians = store => {
  return CLINICIAN_DATA.map(clinicianData => {
    return findOrCreateStoreModel(store, 'clinician', clinicianData);
  });
};

export const createFakeSlots = store => {
  return findOrCreateStoreModel(store, 'slot', SLOT_DATA);
};

export const createFakePractice = (store, practice, relations) => {
  let serializer = store.serializerFor('practice');
  let snapshot = practice._createSnapshot();

  let attrs = serializer.serialize(snapshot, { includeId: false });
  return store.createRecord('practice', {
    id: 'my-practice-id',
    ...attrs,
    ...relations,
    isNewIndividualClientsAllowedToBookAppt: true,
    isNewCouplesAllowedToBookAppt: true,
    isNewContactsAllowedToBookAppt: true,
    featureContactFormCustomSettings: true,
  });
};

export const createFakeReservation = (store, currentPractice) => {
  createFakeClinicians(store);
  createFakeSlots(store);

  let clinician = findOrCreateStoreModel(store, 'clinician', CLINICIAN_DATA[0]);
  let cptCode = findOrCreateStoreModel(store, 'cpt-code', CPT_CODE_DATA);
  let office = findOrCreateStoreModel(store, 'office', OFFICE_DATA);
  let practice = createFakePractice(store, currentPractice, {
    clinician,
    cptCode,
    office,
  });

  return store.createRecord('reservation', {
    id: PRESCREENER_RESERVATION_ID,
    startTime: SLOT_DATA.spots[0].start,
    clientType: 'client',
    clinician,
    cptCode,
    office,
    practice,
  });
};
